import { range } from 'lodash';

import { CustomProperty } from '@evidentid/tprm-portal-lib/models/dashboard';

import { getStandardColumnNames } from '@/modules/entity-management/utils/csv-sample/constants';
import { generateSampleRow } from '@/modules/entity-management/utils/csv-sample/helpers/generateSampleRow';
import {
    getFlattenedCustomPropertyNames,
} from '@/modules/entity-management/utils/get-flattened-custom-property-names/getFlattenedCustomPropertyNames';

export function generateSampleCsvData(
    customProperties: CustomProperty[],
    requirementTypes: string[] = [],
    contactEmailUniquenessEnabled = true,
): (string | number)[][] {
    const getCoverageExpirationColumnLabel =
        (requirementType: string): string => `Existing ${requirementType} Policy Expiration Date`;
    return [
        [
            ...getStandardColumnNames(contactEmailUniquenessEnabled),
            ...getFlattenedCustomPropertyNames(customProperties),
            ...requirementTypes.map(getCoverageExpirationColumnLabel),
        ],
        ...range(0, 10).map(
            () => generateSampleRow(customProperties, requirementTypes, contactEmailUniquenessEnabled),
        ),
    ];
}
